import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner, faChartLine, faBrain, faUsers } from '@fortawesome/free-solid-svg-icons';

interface PreparingMessageProps {
  type?: 'analytics' | 'ai' | 'social' | 'general';
  message?: string;
  className?: string;
}

const PreparingMessage: React.FC<PreparingMessageProps> = ({ 
  type = 'general', 
  message,
  className = ''
}) => {
  const getIcon = () => {
    switch (type) {
      case 'analytics':
        return faChartLine;
      case 'ai':
        return faBrain;
      case 'social':
        return faUsers;
      default:
        return faSpinner;
    }
  };

  const getDefaultMessage = () => {
    switch (type) {
      case 'analytics':
        return 'Analiz verileri hazırlanıyor...';
      case 'ai':
        return 'AI öngörüleri hazırlanıyor...';
      case 'social':
        return 'Sosyal medya verileri hazırlanıyor...';
      default:
        return 'Veriler hazırlanıyor...';
    }
  };

  return (
    <div className={`flex flex-col items-center justify-center h-full min-h-[200px] ${className}`}>
      <div className="relative mb-4">
        <div className="w-12 h-12 bg-gradient-to-br from-purple-500/20 to-blue-500/20 rounded-xl flex items-center justify-center">
          <FontAwesomeIcon 
            icon={getIcon()} 
            className="text-purple-400 text-lg animate-pulse" 
          />
        </div>
        <div className="absolute -top-1 -right-1 w-4 h-4 bg-purple-500 rounded-full animate-ping"></div>
      </div>
      
      <div className="text-center">
        <h3 className="text-white font-medium mb-2">
          {message || getDefaultMessage()}
        </h3>
        <p className="text-white/60 text-sm max-w-xs">
          {type === 'analytics' && 'Sosyal medya hesaplarınızın analizini yapıyoruz'}
          {type === 'ai' && 'AI algoritmalarımız verilerinizi işliyor'}
          {type === 'social' && 'Sosyal medya platformlarından veri topluyoruz'}
          {type === 'general' && 'Lütfen biraz bekleyin'}
        </p>
      </div>
      
      <div className="mt-6 flex space-x-1">
        <div className="w-2 h-2 bg-purple-400 rounded-full animate-bounce" style={{ animationDelay: '0ms' }}></div>
        <div className="w-2 h-2 bg-purple-400 rounded-full animate-bounce" style={{ animationDelay: '150ms' }}></div>
        <div className="w-2 h-2 bg-purple-400 rounded-full animate-bounce" style={{ animationDelay: '300ms' }}></div>
      </div>
    </div>
  );
};

export default PreparingMessage;
